import { ALERT_CONFIG } from '@cyberint/common-utils';
import { t } from '../i18n';

const { USER_DEFINED_SAVED_QUERY, OTHER } = ALERT_CONFIG.ALERT_TYPES;

export const getAlertTitle = alert => {
  const isIncludedInTitleDisplayingTypes = [OTHER, USER_DEFINED_SAVED_QUERY].includes(alert.type);
  if (isIncludedInTitleDisplayingTypes) {
    return alert?.title || t(`subtype.${alert.subtype}`);
  }

  return alert.subtype ? t(`subtype.${alert.subtype}`) : alert?.title || t('fields.alert_id');
};

const insufficientContent = content =>
  !content ||
  content.toLowerCase().includes('no content was applied') ||
  content.toLowerCase() === 'none' ||
  content.length < 3;

export const getApproveMissingDetails = alert => {
  const invalidDescription = insufficientContent(alert?.description);
  const invalidRecommendations = insufficientContent(alert?.recommendation);

  if (invalidDescription && invalidRecommendations) {
    return t('update.modal.missingDetails.contentMulti', {
      field1: t('update.modal.description'),
      field2: t('update.modal.recommendations')
    });
  }
  if (invalidDescription) {
    return t('update.modal.missingDetails.content', {
      field: t('update.modal.description')
    });
  }
  if (invalidRecommendations) {
    return t('update.modal.missingDetails.content', {
      field: t('update.modal.recommendations')
    });
  }

  return null;
};
